import React from "react"

import ToolbarContainer_s from "components/subnav/toolbar-styles"

type IToolbar = {
  children: any
  className?: string
}

const Toolbar = (props: IToolbar) => {
  return (
    <ToolbarContainer_s id="rdcf-toolbar" className={props.className}>
      { props.children }
    </ToolbarContainer_s>
  )
}

export default Toolbar
